import React, { createContext, useContext } from "react";
import { GoogleOAuthProvider } from "@react-oauth/google";

const GoogleClientIdContext = createContext(null);

export const useGoogleClientId = () => useContext(GoogleClientIdContext);

const GoogleProviderWrapper = ({ clientId, children }) => {
  if (!clientId) return <>{children}</>; 
  return (
    <GoogleClientIdContext.Provider value={clientId}>
      <GoogleOAuthProvider clientId={clientId}>{children}</GoogleOAuthProvider>
    </GoogleClientIdContext.Provider>
  );
};

export default GoogleProviderWrapper;
